"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.companyStageNames = exports.CompanyStage = exports.AttachmentReferenceType = void 0;
var AttachmentReferenceType;
(function (AttachmentReferenceType) {
    AttachmentReferenceType["URL"] = "url";
    AttachmentReferenceType["File"] = "file";
})(AttachmentReferenceType || (exports.AttachmentReferenceType = AttachmentReferenceType = {}));
var CompanyStage;
(function (CompanyStage) {
    CompanyStage["bootstrapped"] = "bootstrapped";
    CompanyStage["preSeed"] = "pre_seed";
    CompanyStage["seed"] = "seed";
    CompanyStage["seriesA"] = "series_a";
    CompanyStage["seriesB"] = "series_b";
    CompanyStage["seriesC"] = "series_c";
    CompanyStage["postSeriesC"] = "post_series_c";
})(CompanyStage || (exports.CompanyStage = CompanyStage = {}));
exports.companyStageNames = {
    [CompanyStage.bootstrapped]: "Bootstrapped",
    [CompanyStage.preSeed]: "Pre-Seed",
    [CompanyStage.seed]: "Seed",
    [CompanyStage.seriesA]: "Series A",
    [CompanyStage.seriesB]: "Series B",
    [CompanyStage.seriesC]: "Series C",
    [CompanyStage.postSeriesC]: "Post Series C",
};
